var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M42,93.6a42,42,0,1,1,42-42,42.059,42.059,0,0,1-42,42m0-73.8A31.8,31.8,0,1,0,73.8,51.6,31.881,31.881,0,0,0,42,19.8",
    transform: "translate(0 -9.6)",
    fill: "#3cbb9c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOuter);
export default __webpack_public_path__ + "static/media/clockOuter.f8d3755c25eed9ac6471afdcbfacf650.svg";
export { ForwardRef as ReactComponent };